<div class="rewards-tab" *transloco="let t">
  <div class="pin-form">
    <div class="type-toggle">
      <label><input type="radio" [formControl]="targetType" value="quest" /> {{ t('cardsAdminRewardTargetQuest') }}</label>
      <label><input type="radio" [formControl]="targetType" value="trip" /> {{ t('cardsAdminRewardTargetTrip') }}</label>
    </div>

    <input class="search-input" [formControl]="search" [placeholder]="t('cardsAdminRewardSearch')" />

    @if (targets().length) {
      <ul class="target-list">
        @for (target of targets(); track target.id) {
          <li [class.selected]="selectedTarget()?.id === target.id" (click)="selectTarget(target)">
            <span class="target-name">{{ target.name }}</span>
            @if (target.questsCount !== undefined) {
              <span class="target-meta">{{ target.questsCount }}q / {{ target.obelisksCount }}p</span>
            }
            @if (target.type) {
              <span class="target-meta">{{ target.type }}</span>
            }
            @if (target.createdAt) {
              <span class="target-meta">{{ target.createdAt | date: 'shortDate' }}</span>
            }
            @if (target.isPrivate) {
              <span class="target-meta">private</span>
            }
          </li>
        }
      </ul>
    } @else if (search.value.trim().length >= 2) {
      <div class="empty">{{ t('cardsAdminRewardNoTargets') }}</div>
    }

    <select [formControl]="selectedCardId">
      <option [ngValue]="null">{{ t('cardsAdminRewardCard') }}</option>
      @for (card of cards.value(); track card.id) {
        <option [ngValue]="card.id">
          {{ card.name.en }} ({{ card.rarity }})
          @if (card.hidden) { &middot; {{ t('cardsAdminCatalogHidden') }} }
          @if (card.noRandomDrop) { &middot; {{ t('cardsAdminCatalogNoRandomDrop') }} }
        </option>
      }
    </select>

    <button class="pin-button" [disabled]="!selectedTarget() || !selectedCardId.value" (click)="pin()">
      {{ t('cardsAdminRewardPin') }}
    </button>
  </div>

  @if (rewards.value().length) {
    <table class="rewards-table">
      <tr>
        <th></th>
        <th>{{ t('cardsAdminRewardCard') }}</th>
        <th>{{ t('cardsAdminRewardTarget') }}</th>
        <th></th>
        <th></th>
      </tr>
      @for (reward of rewards.value(); track reward.id) {
        <tr>
          <td><img class="thumb" [src]="reward.thumbUrl" alt="card" /></td>
          <td>{{ reward.cardName.en }} <span class="rarity">{{ reward.rarity }}</span></td>
          <td>
            <span class="type-chip">{{ reward.targetType === 'quest' ? t('cardsAdminRewardTargetQuest') : t('cardsAdminRewardTargetTrip') }}</span>
            {{ reward.targetName }}
          </td>
          <td>{{ reward.createdAt | date: 'short' }}</td>
          <td><button (click)="remove(reward.id)">{{ t('cardsAdminRewardRemove') }}</button></td>
        </tr>
      }
    </table>
  } @else {
    <div class="empty">{{ t('cardsAdminRewardEmpty') }}</div>
  }
</div>
